<script setup lang="ts">
import LogoComponent from '#assets/crf-logo-horizontal.svg';

defineProps({
  title: { type: String, required: true }
});
</script>

<template>
  <div
    class="w-full flex justify-center items-center fixed top-0 left-0 h-[5.125rem] border-b border-default-neutral-217"
  >
    <div class="flex shrink justify-center items-center gap-4">
      <LogoComponent class="h-[3.125rem] w-[9.25rem] rounded border p-3 border-default-neutral-217" />
      <div class="bg-default-neutral-217 w-px h-[3.125rem]"></div>
      <span class="text-base font-bold">
        {{ title }}
      </span>
    </div>
  </div>
</template>
